export const NAME_MAX_LENGTH = 255;
